import React, {Component} from 'react';

import {Form, ErrorContainer} from 'form';
import {Link} from 'components/ReactRouterDomLocalized';

import {recoverPassword} from 'backend-helpers/passwordRecover';

import {t} from 'l10n';

export default class ModalMenuForgotPasswordForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            processing: false,
            done: false,
            captchaToken: null,
            captchaError: ''
        };

        this.captchaRef = React.createRef();
        this.captchaWidgetId = null;
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        let intervalId = null;

        const initCaptcha = () => {
            if (this.captchaRef.current && window.turnstile) {
                this.captchaWidgetId = window.turnstile.render(this.captchaRef.current, {
                    sitekey: '0x4AAAAAACYQvImRXMQ5dwGT',
                    callback: (token) => {
                        this.setState({
                            captchaToken: token,
                            captchaError: ''
                        });
                    },
                    'expired-callback': () => {
                        this.setState({ captchaToken: null });
                    }
                });

                clearInterval(intervalId);
            }
        };

        intervalId = window.setInterval(initCaptcha, 100);

        this._intervalCleanup = () => clearInterval(intervalId);
    }

    onSubmit(formData, setErrors) {
        if (this.state.processing) return false;

        if (!this.state.captchaToken) {
            this.setState({ captchaError: t('Please confirm you are not a robot') });
            return;
        }

        recoverPassword({
            ...formData,
            captcha: this.state.captchaToken
        })
            .then(() => {
                this.setState({
                    done: true,
                    processing: false
                });
            })
            .catch((error) => {
                setErrors(error.messages || error.message, true);
                this.setState({
                    processing: false,
                    captchaToken: null
                })
            });

        this.setState({processing: true})
    }

    render() {
        return (
            <div>
                <p className="name">
                    <span>{t('Receive password')}</span>
                    <Link to="/?login" className="header-button">{t('Log in')}</Link>
                </p>
                {!this.state.done ?

                    <Form onSubmit={this.onSubmit}>
                        <ErrorContainer data-errorcontainer={true} allowHtml />

                        <div className="space-between">
                            <div>
                                <input name="email" placeholder="Email" type="email"/>
                            </div>
                        </div>

                        <div ref={this.captchaRef} style={{ margin: '10px 0' }} />

                        {this.state.captchaError && (
                            <div className="form-error" style={{ marginBottom: '10px', color: '#a23330', fontSize: '12px' }}>
                                {this.state.captchaError}
                            </div>
                        )}

                        <div className="space-between">
                            <button type='submit' className={!this.state.processing ? 'btn-submit' : 'btn-submit loading'}>{t('Send')}</button>
                        </div>
                        <div>
                            <p className="help-text">{t('Enter your email address or nick to receive your password immediately.')}</p>
                        </div>
                    </Form>

                    :

                    <p className="help-text">{t('Message with the password reset instructions has been sent to your email.')}</p>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/ModalMenu/ModalMenuForgotPasswordForm.js